var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99936 6C3.26297 6 2.66602 6.59696 2.66602 7.33334V13.3333C2.66602 14.0697 3.26298 14.6667 3.99936 14.6667H11.9993C12.7357 14.6667 13.3327 14.0697 13.3327 13.3333V7.33334C13.3327 6.59696 12.7357 6 11.9993 6H3.99936ZM6.66597 9.33333C6.66597 8.59695 7.26292 8 7.9993 8C8.73568 8 9.33263 8.59695 9.33263 9.33333C9.33263 9.82684 9.06452 10.2577 8.666 10.4883V11.9999C8.666 12.3681 8.36753 12.6665 7.99933 12.6665C7.63114 12.6665 7.33266 12.3681 7.33266 11.9999V10.4883C6.93411 10.2578 6.66597 9.82687 6.66597 9.33333Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 32976",
    d: "M5.33398 4.66667C5.33398 3.19391 6.52789 2 8.00065 2V2C9.47341 2 10.6673 3.19391 10.6673 4.66667V7.33333H5.33398V4.66667Z",
    stroke: "#111111",
    strokeWidth: 1.33334
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecret);
export default __webpack_public_path__ + "static/media/Secret.f26100a85f2f0eb8ec00b843015cca22.svg";
export { ForwardRef as ReactComponent };